import { ReactNode } from 'react';
import { GridColDef } from '@molecules/dataDisplay/dataGrid';
import { MenuButton } from '@atoms/buttons';
import { GridValidRowModel } from './gridValidRowModel';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ActionMenuItem<T extends GridValidRowModel = any> = {
  label?: ReactNode;
  renderLabel?: (data: T) => ReactNode;
  onClick?: (data: T) => void;
  key: string;
};
export function getActionMenuColumn<T extends GridValidRowModel>(items: ActionMenuItem<T>[]): GridColDef<T, unknown> {
  return {
    field: 'controls',
    headerName: '',
    width: 44,
    minWidth: 44,
    resizable: false,
    disableReorder: true,
    renderCell: (row) => {
      return (
        <MenuButton
          id={row.id.toString()}
          items={items.map((item) => ({
            ...item,
            label: item.renderLabel ? item.renderLabel(row.row) : item.label,
            onClick: () => item.onClick?.(row.row),
          }))}
        />
      );
    },
  };
}
